// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator___zjyw","reference":"Indicator_reference__VTkQs"};